const Foreigner: any = ({setFormStep}: any) => {
  const handleBackRule = () => {
    setFormStep(0)
  }
  return (
    <div>
      <div className=''>
        <div>
          <div className='fs-4 fw-bolder'>Head office</div>
          <div>
            <span className='d-block mt-1'>
              9th floor, Lotte Center Hanoi, 54 Lieu Giai, Ba Dinh, Ha Noi
            </span>
            <span className='d-block'>
              Tel: <span className='nhsv_noctice fw-bolder'>1900.1055</span> | Fax:{' '}
              <span className='nhsv_noctice fw-bolder'>0243.941.0248</span>
            </span>
          </div>
        </div>
        <div className='mt-4'>
          <div className='fs-4 fw-bolder'>Hanoi branch</div>
          <div>
            <span className='d-block mt-1'>
              Somerset Grand Hanoi, No. 49 Hai Ba Trung, Tran Hung Dao Ward, Hoan Kiem District,
              Hanoi
            </span>
            <span className='d-block'>
              Tel: <span className='nhsv_noctice fw-bolder'>1900.1055</span> | Fax:{' '}
              <span className='nhsv_noctice fw-bolder'>0243.941.0248</span>
            </span>
          </div>
        </div>
        <div className='mt-4'>
          <div className='fs-4 fw-bolder'>Ho Chi Minh branch</div>
          <div>
            <span className='d-block mt-1'>
              3rd Floor, President Place Building, 93 Nguyen Du, Ben Nghe Ward, District 1, HCMC
            </span>
            <span className='d-block'>
              Tel: <span className='nhsv_noctice fw-bolder'>0283.838.5917</span> | Fax:{' '}
              <span className='nhsv_noctice fw-bolder'>0243.941.0248</span>
            </span>
          </div>
        </div>
      </div>

      <button className='btn btn-lg back-btn mt-8' onClick={handleBackRule}>
        <span>
          <i className='fa fa-arrow-left fa-3x fa-left-color'></i>
        </span>
        Back
      </button>
    </div>
  )
}

export {Foreigner}
